import React, { useState } from 'react';
import * as styles from '../base.scss';
import { translate } from 'Shared/translate';
import ClassificationGroup from '../Classification/ClassificationGroup';
import Button from 'Shared/Button';
import classnames from 'classnames';
import MyMenigoIcon from '../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import { scrollPosition } from 'SiteLayout/Root';
const ClassificationBlock = ({ productViewModel, selectedVariant, isProductPage }) => {
    const [isOpen, setOpen] = useState(false);
    const ButtonClick = () => {
        setOpen(!isOpen);
        if (isOpen) {
            const headerElement = document.getElementById('mainHeader');
            const element = document.getElementById('ProductClassification');
            const offset = !!element ? element.offsetTop : 0;
            scrollPosition(offset - headerElement.offsetHeight);
        }
    };
    const showEmpty = false;
    const list = isProductPage && productViewModel.productInformationList ? productViewModel.productInformationList.map(x => (Object.assign(Object.assign({}, x), { items: x.items.filter(x => !["Artikelnummer", "Märke"].includes(x.label)) }))) : productViewModel.productInformationList;
    const showButton = showEmpty
        ? !!list && list.length > 1
        : !!list && list.filter(x => x.items.filter(x => !!x.valueAsString && !!x.isVisible).length).length > 1;
    const buttonText = isOpen
        ? translate('/Product/ProductClassification/ShowLess')
        : translate('/Product/ProductClassification/ShowMore');
    const classificationList = (React.createElement("div", { id: "ProductClassification", className: classnames(styles.productClassification__Box, !!isOpen && styles.isOpen) },
        React.createElement("ul", { className: styles.productClassification__List }, !!list &&
            list
                .slice(0, isOpen ? list.length : 1)
                .map((itemgroup, index) => (React.createElement(ClassificationGroup, { key: 'group_' + index, showEmpty: showEmpty, shouldRender: showEmpty
                    ? !!itemgroup.items && itemgroup.items.filter(x => !!x.isVisible).length > 0
                    : !!itemgroup.items.filter(x => !!x.valueAsString && !!x.isVisible).length, title: itemgroup.header, items: itemgroup.items })))),
        showButton && (React.createElement(Button, { className: styles.showMoreLessButton, onClick: ButtonClick, appearance: 'bare' },
            buttonText,
            " ",
            React.createElement(MyMenigoIcon, { name: isOpen ? 'dropdownArrowUp' : 'dropdownArrowDown' })))));
    return React.createElement(React.Fragment, null, classificationList);
};
export default ClassificationBlock;
